<template>
    <div class="group cursor-pointer"
        :class="is_dropping ? 'bg-blue-100' : 'bg-white'"
        @click="$emit('click')"
        @drop="onDrop"
        @dragenter.prevent
        @dragover.prevent="onDragOver"
        @dragleave.prevent="onDragOut"
    >
        <div class="pl-3 py-2.5"
            :class="selected ? 'bg-gray-warm-100' : 'bg-transparent'"
        >
            <div class="flex items-center justify-between">
                <div class="flex items-start leading-tight text-base"
                    :class="selected ? 'text-black'
                        : (count ? 'text-green-warm-700 group-hover:text-blue-600' : 'text-gray-600 group-hover:text-blue-600')
                    "
                >
                    <folder-icon size="16"
                        class="flex-none mr-2"
                        :class="count ? 'text-green-warm-600 group-hover:text-green-warm-800' :
                            (selected ? 'text-black' : 'text-gray-300 group-hover:text-blue-600')"
                        :stroke-width="2"
                        :fill="count ? '#8ca100' : 'none'"
                    />

                    {{ folder.name }}

                    <span v-if="count"
                        :class="[
                            selected ? 'bg-green-warm-200 text-green-warm-800' : 'bg-green-warm-200 text-green-warm-800',
                            'ml-3 hidden rounded-full px-2.5 py-0.5 text-xs font-medium md:inline-block'
                        ]">
                            {{ count }}
                    </span>
                </div>

                <div class="w-6 flex-none flex items-center justify-end pr-2">
                    <span v-if="selected">
                        <chevron-right-icon size="18" class="text-gray-600" />
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DocumentFolder from './document-folder.vue';
import { ChevronRightIcon, FolderIcon } from 'vue-feather-icons';

export default {
    name: 'document-folder',

    components: {
        DocumentFolder,
        ChevronRightIcon,
        FolderIcon,
    },

    props: {
        folder: {},
        property_id: {},
        count: {},
        selected: { default: false },
    },

    data() {
        return {
            is_dropping: false,
        }
    },

    methods: {
        onDrop(event, list) {
            this.is_dropping = false;
            const file_id = event.dataTransfer.getData('itemId');

            if (file_id) {
                axios.patch('/properties/' + this.property_id + '/documents/' + file_id, {
                    folder_id: this.folder.id,
                }).then(response => {
                    this.$emit('updatedDocument', response.data.data);
                    this.$emit('selectFolder', this.folder.id);
                }).catch(error => {
                    console.log(error.response);
                });
            }
        },
        onDragOver() {
            this.is_dropping = true;
        },
        onDragOut() {
            this.is_dropping = false;
        },
    },
}
</script>
